// DEPRECATED
import createCompositor from '../createCompositor';
export default createCompositor;